/**
 * The path of an organization's legal pages on remi.homes (SPEC-2782).
 *
 * Mirrors remi-api `app/services/legal_slug.py`, which validates and stores the slug; the
 * frontend only proposes one from the org name and shows the resulting links.
 */

const SLUG_RE = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export const isValidLegalSlug = (slug: string): boolean =>
  slug.length <= 64 && slug !== 'id' && SLUG_RE.test(slug);

/** "The Fun Realtor Florida" -> "fun-realtor-florida". The server adds -2, -3, ... if taken. */
export const proposeLegalSlug = (orgName: string): string => {
  const ascii = orgName.normalize('NFKD').replace(/[̀-ͯ]/g, '');
  let words: string[] =
    ascii
      .toLowerCase()
      .replace(/&/g, ' and ')
      .match(/[a-z0-9]+/g) ?? [];
  if (words.length > 1 && words[0] === 'the') words = words.slice(1);
  const base =
    words
      .join('-')
      .slice(0, 60)
      .replace(/^-+|-+$/g, '') || 'org';
  return base === 'id' ? 'id-org' : base;
};

/** The hosted page; by slug once saved, by organization id until then. */
export const legalPageUrl = (
  baseUrl: string,
  organizationId: string,
  slug: string | null | undefined,
  document: 'terms' | 'privacy'
): string => `${baseUrl}/legal/${slug ? slug : `id/${organizationId}`}/${document}`;
